// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ERF ConstructionOS — Responsive Design-System Primitives
 * ─────────────────────────────────────────────────────────
 * Mobile-first. Canonical breakpoints as CSS variables so every
 * module (Phases 2-8 + Architect portal) consumes the same tokens.
 *
 * Core invariants baked in:
 *   • \`--bp-*\` breakpoints are the ONLY breakpoints — no inline magic.
 *   • Flex-text children ALWAYS get \`min-width: 0\` so flex-shrink can
 *     never crush text containers to intrinsic character width.
 *   • Headings wrap at WORD BOUNDARIES only (\`overflow-wrap: break-word\`).
 *     Never \`word-break: break-all\` on display text (that's the
 *     character-stacking anti-pattern that triggered this repair).
 *   • Primary interactive controls have ≥44×44 CSS px tap targets on
 *     phones. Shrinks to 32px minimum height on sm+ for density.
 *   • No \`overflow: hidden\` + \`white-space: nowrap\` on text content as
 *     a way to conceal responsive failure. If text doesn't fit, the
 *     layout wraps — never truncates.
 */

:root {
  --bp-sm: 480px;
  --bp-md: 640px;
  --bp-lg: 1024px;
  --bp-xl: 1280px;
  --bp-2xl: 1440px;
  --ds-touch-target: 44px;
  --ds-touch-target-dense: 32px;
}

/* ds-stack — vertical rhythm primitive. Children stack with
   consistent gap on phones; collapse to flex-row on sm+. */
.ds-stack {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

/* ds-cluster — horizontal flex cluster with wrap. ALWAYS puts
   \`min-width: 0\` on direct text children via descendant combinator
   so flex-shrink can't crush them to character width. */
.ds-cluster {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  align-items: center;
}
.ds-cluster > * { min-width: 0; }

/* ds-card — card wrapper. Enables **container-query addressing** so
   the card's inner responsive rules key off the card's own inline size,
   not the viewport. ALSO pins its surface tokens so a dark-mode theme
   flip can never reach the card body text.
   Browser matrix (container queries): Chrome 105+, Safari 16+,
   iOS Safari 16+, Firefox 110+. Older engines fall through to the
   base \`.ds-card-header\` rule (column-stacked, no character-stack).

   CONTRAST REPAIR (SHA f3d12…): the Preview environment forces a
   runtime theme flip that routes shadcn's \`--card\` CSS variable to
   dark navy #123056, collapsing ALL \`text-erf-dark\` descendants to
   1.44:1 contrast. We override \`--card\`, \`--card-foreground\`,
   \`--border\`, and the ambient \`--background\` / \`--foreground\` within
   the .ds-card subtree to a known-safe cream + near-black token pair.
   Explicit \`background-color\` + \`color\` are belt-and-suspenders in
   case a descendant resolves to inline \`bg-card\` / \`text-card-fg\`. */
.ds-card {
  container-type: inline-size;
  container-name: card;

  /* HSL-triplet overrides for shadcn's CSS variables (\`hsl(var(--…))\`). */
  --card: 48 24% 98%;              /* #FEFCF7 cream */
  --card-foreground: 240 4% 6%;    /* #0F0F10 near-black */
  --background: 48 24% 98%;        /* for inner surfaces that read --background */
  --foreground: 240 4% 6%;
  --border: 48 14% 87%;            /* #E6E1D4 cream border */
  --input: 48 14% 87%;
  --muted: 60 8% 94%;
  --muted-foreground: 240 3% 40%;

  /* Hard pins (defense-in-depth). \`!important\` is intentional: the
     Preview environment compiles Tailwind utilities AFTER this file,
     and \`bg-card\` on the shadcn Card wrapper would otherwise win the
     specificity tie and route through a theme-flipped \`--card\` value.
     We own this surface, we pin it. */
  background-color: #FEFCF7 !important;
  color: #0F0F10 !important;
}
/* Outline buttons inside .ds-card need ink + visible gold border on
   cream. 4.5:1 (text) and 3:1 (border) achieved. The shadcn outline
   variant class is matched by substring to stay version-robust. */
.ds-card [class*="border-input"],
.ds-card button[class*="variant-outline"] {
  background-color: #FEFCF7;
  color: #0F0F10;
  border-color: #B8892B;  /* erf-gold on cream = 3.4:1 UI boundary */
}
/* Masked-preview blocks (translucent cream pill). Ensure the ink is
   explicit so children don't inherit a navy ambient. */
.ds-card [data-testid^="integration-masked-"] {
  background-color: #F3F3EC;
  color: #0F0F10;
}

/* ds-card-header — the primitive that fixes the Pass 2 character-stack
   defect at EVERY card width. Base rule: column-stacked (safe at any
   width, no crushing possible). Container query flips to row only when
   the CARD inline-size ≥ 28rem (≈448px) — tuned so title (≥8rem) + chip
   (~14rem for "Configured (platform secret)") + gap fit side-by-side
   with margin to spare. Belt-and-suspenders: \`flex-wrap: wrap\` plus a
   title \`min-width: 8rem\` floor so the chip wraps to its own line
   rather than ever crushing the title below ~128px. */
.ds-card-header {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  align-items: flex-start;
}
.ds-card-header > .ds-card-header__title {
  min-width: 0;
  flex: 1 1 auto;
  overflow-wrap: break-word;
  word-break: normal;
}
.ds-card-header > .ds-card-header__chip {
  align-self: flex-start;
  max-width: 100%;
}
@container card (min-width: 28rem) {
  .ds-card-header {
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  .ds-card-header > .ds-card-header__title {
    min-width: 8rem;
    flex: 1 1 8rem;
  }
  .ds-card-header > .ds-card-header__chip {
    flex-shrink: 0;
  }
}

/* ds-action-bar — card footer action cluster. On phones, buttons stack
   vertically full-width (≥44px tap target). On ≥480px, buttons sit
   inline and shrink to natural width. */
.ds-action-bar {
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
  padding-top: 0.25rem;
}
.ds-action-bar > * {
  width: 100%;
  min-height: var(--ds-touch-target);
}
.ds-action-bar > a,
.ds-action-bar > a > button {
  width: 100%;
}
@media (min-width: 480px) {
  .ds-action-bar {
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.375rem;
  }
  .ds-action-bar > * {
    width: auto;
    min-height: var(--ds-touch-target-dense);
  }
  .ds-action-bar > a,
  .ds-action-bar > a > button {
    width: auto;
  }
}

/* ds-touch — enforce 44×44 CSS px minimum tap target. Apply to any
   interactive control that's visually smaller than the target so the
   invisible hit box matches WCAG 2.5.5. */
.ds-touch {
  min-width: var(--ds-touch-target);
  min-height: var(--ds-touch-target);
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

/* ds-text-safe — anti-character-stacking utility. Apply to any text
   container that lives inside a flex row. Combines \`min-width: 0\`
   with word-boundary wrapping. */
.ds-text-safe {
  min-width: 0;
  overflow-wrap: break-word;
  word-break: normal;
}

/* Narrow-viewport guard: if ANY admin surface accidentally sets
   \`white-space: nowrap\` on a text container wider than its parent,
   the result would overflow — ban that pattern in headings via the
   lint test in tests/test_responsive_audit.py. */
`, "",{"version":3,"sources":["webpack://./src/design-system/responsive.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;EAiBE;;AAEF;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;2DAC2D;AAC3D;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;;wDAEwD;AACxD;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;AACA,kBAAkB,YAAY,EAAE;;AAEhC;;;;;;;;;;;;;;;qEAeqE;AACrE;EACE,2BAA2B;EAC3B,oBAAoB;;EAEpB,wEAAwE;EACxE,kBAAkB,eAAe,kBAAkB;EACnD,4BAA4B,KAAK,uBAAuB;EACxD,wBAAwB,SAAS,8CAA8C;EAC/E,uBAAuB;EACvB,oBAAoB,aAAa,yBAAyB;EAC1D,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;;EAE9B;;;;sCAIoC;EACpC,oCAAoC;EACpC,yBAAyB;AAC3B;AACA;;kEAEkE;AAClE;;EAEE,yBAAyB;EACzB,cAAc;EACd,qBAAqB,GAAG,0CAA0C;AACpE;AACA;uDACuD;AACvD;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;;;;;;sDAOsD;AACtD;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE;IACE,mBAAmB;IACnB,uBAAuB;IACvB,8BAA8B;IAC9B,eAAe;EACjB;EACA;IACE,eAAe;IACf,cAAc;EAChB;EACA;IACE,cAAc;EAChB;AACF;;AAEA;;wCAEwC;AACxC;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,kCAAkC;AACpC;AACA;;EAEE,WAAW;AACb;AACA;EACE;IACE,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,aAAa;EACf;EACA;IACE,WAAW;IACX,wCAAwC;EAC1C;EACA;;IAEE,WAAW;EACb;AACF;;AAEA;;0CAE0C;AAC1C;EACE,iCAAiC;EACjC,kCAAkC;EAClC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;iCAEiC;AACjC;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;;iDAGiD","sourcesContent":["/* ERF ConstructionOS — Responsive Design-System Primitives\n * ─────────────────────────────────────────────────────────\n * Mobile-first. Canonical breakpoints as CSS variables so every\n * module (Phases 2-8 + Architect portal) consumes the same tokens.\n *\n * Core invariants baked in:\n *   • `--bp-*` breakpoints are the ONLY breakpoints — no inline magic.\n *   • Flex-text children ALWAYS get `min-width: 0` so flex-shrink can\n *     never crush text containers to intrinsic character width.\n *   • Headings wrap at WORD BOUNDARIES only (`overflow-wrap: break-word`).\n *     Never `word-break: break-all` on display text (that's the\n *     character-stacking anti-pattern that triggered this repair).\n *   • Primary interactive controls have ≥44×44 CSS px tap targets on\n *     phones. Shrinks to 32px minimum height on sm+ for density.\n *   • No `overflow: hidden` + `white-space: nowrap` on text content as\n *     a way to conceal responsive failure. If text doesn't fit, the\n *     layout wraps — never truncates.\n */\n\n:root {\n  --bp-sm: 480px;\n  --bp-md: 640px;\n  --bp-lg: 1024px;\n  --bp-xl: 1280px;\n  --bp-2xl: 1440px;\n  --ds-touch-target: 44px;\n  --ds-touch-target-dense: 32px;\n}\n\n/* ds-stack — vertical rhythm primitive. Children stack with\n   consistent gap on phones; collapse to flex-row on sm+. */\n.ds-stack {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n/* ds-cluster — horizontal flex cluster with wrap. ALWAYS puts\n   `min-width: 0` on direct text children via descendant combinator\n   so flex-shrink can't crush them to character width. */\n.ds-cluster {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  align-items: center;\n}\n.ds-cluster > * { min-width: 0; }\n\n/* ds-card — card wrapper. Enables **container-query addressing** so\n   the card's inner responsive rules key off the card's own inline size,\n   not the viewport. ALSO pins its surface tokens so a dark-mode theme\n   flip can never reach the card body text.\n   Browser matrix (container queries): Chrome 105+, Safari 16+,\n   iOS Safari 16+, Firefox 110+. Older engines fall through to the\n   base `.ds-card-header` rule (column-stacked, no character-stack).\n\n   CONTRAST REPAIR (SHA f3d12…): the Preview environment forces a\n   runtime theme flip that routes shadcn's `--card` CSS variable to\n   dark navy #123056, collapsing ALL `text-erf-dark` descendants to\n   1.44:1 contrast. We override `--card`, `--card-foreground`,\n   `--border`, and the ambient `--background` / `--foreground` within\n   the .ds-card subtree to a known-safe cream + near-black token pair.\n   Explicit `background-color` + `color` are belt-and-suspenders in\n   case a descendant resolves to inline `bg-card` / `text-card-fg`. */\n.ds-card {\n  container-type: inline-size;\n  container-name: card;\n\n  /* HSL-triplet overrides for shadcn's CSS variables (`hsl(var(--…))`). */\n  --card: 48 24% 98%;              /* #FEFCF7 cream */\n  --card-foreground: 240 4% 6%;    /* #0F0F10 near-black */\n  --background: 48 24% 98%;        /* for inner surfaces that read --background */\n  --foreground: 240 4% 6%;\n  --border: 48 14% 87%;            /* #E6E1D4 cream border */\n  --input: 48 14% 87%;\n  --muted: 60 8% 94%;\n  --muted-foreground: 240 3% 40%;\n\n  /* Hard pins (defense-in-depth). `!important` is intentional: the\n     Preview environment compiles Tailwind utilities AFTER this file,\n     and `bg-card` on the shadcn Card wrapper would otherwise win the\n     specificity tie and route through a theme-flipped `--card` value.\n     We own this surface, we pin it. */\n  background-color: #FEFCF7 !important;\n  color: #0F0F10 !important;\n}\n/* Outline buttons inside .ds-card need ink + visible gold border on\n   cream. 4.5:1 (text) and 3:1 (border) achieved. The shadcn outline\n   variant class is matched by substring to stay version-robust. */\n.ds-card [class*=\"border-input\"],\n.ds-card button[class*=\"variant-outline\"] {\n  background-color: #FEFCF7;\n  color: #0F0F10;\n  border-color: #B8892B;  /* erf-gold on cream = 3.4:1 UI boundary */\n}\n/* Masked-preview blocks (translucent cream pill). Ensure the ink is\n   explicit so children don't inherit a navy ambient. */\n.ds-card [data-testid^=\"integration-masked-\"] {\n  background-color: #F3F3EC;\n  color: #0F0F10;\n}\n\n/* ds-card-header — the primitive that fixes the Pass 2 character-stack\n   defect at EVERY card width. Base rule: column-stacked (safe at any\n   width, no crushing possible). Container query flips to row only when\n   the CARD inline-size ≥ 28rem (≈448px) — tuned so title (≥8rem) + chip\n   (~14rem for \"Configured (platform secret)\") + gap fit side-by-side\n   with margin to spare. Belt-and-suspenders: `flex-wrap: wrap` plus a\n   title `min-width: 8rem` floor so the chip wraps to its own line\n   rather than ever crushing the title below ~128px. */\n.ds-card-header {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  align-items: flex-start;\n}\n.ds-card-header > .ds-card-header__title {\n  min-width: 0;\n  flex: 1 1 auto;\n  overflow-wrap: break-word;\n  word-break: normal;\n}\n.ds-card-header > .ds-card-header__chip {\n  align-self: flex-start;\n  max-width: 100%;\n}\n@container card (min-width: 28rem) {\n  .ds-card-header {\n    flex-direction: row;\n    align-items: flex-start;\n    justify-content: space-between;\n    flex-wrap: wrap;\n  }\n  .ds-card-header > .ds-card-header__title {\n    min-width: 8rem;\n    flex: 1 1 8rem;\n  }\n  .ds-card-header > .ds-card-header__chip {\n    flex-shrink: 0;\n  }\n}\n\n/* ds-action-bar — card footer action cluster. On phones, buttons stack\n   vertically full-width (≥44px tap target). On ≥480px, buttons sit\n   inline and shrink to natural width. */\n.ds-action-bar {\n  display: flex;\n  flex-direction: column;\n  gap: 0.375rem;\n  padding-top: 0.25rem;\n}\n.ds-action-bar > * {\n  width: 100%;\n  min-height: var(--ds-touch-target);\n}\n.ds-action-bar > a,\n.ds-action-bar > a > button {\n  width: 100%;\n}\n@media (min-width: 480px) {\n  .ds-action-bar {\n    flex-direction: row;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 0.375rem;\n  }\n  .ds-action-bar > * {\n    width: auto;\n    min-height: var(--ds-touch-target-dense);\n  }\n  .ds-action-bar > a,\n  .ds-action-bar > a > button {\n    width: auto;\n  }\n}\n\n/* ds-touch — enforce 44×44 CSS px minimum tap target. Apply to any\n   interactive control that's visually smaller than the target so the\n   invisible hit box matches WCAG 2.5.5. */\n.ds-touch {\n  min-width: var(--ds-touch-target);\n  min-height: var(--ds-touch-target);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* ds-text-safe — anti-character-stacking utility. Apply to any text\n   container that lives inside a flex row. Combines `min-width: 0`\n   with word-boundary wrapping. */\n.ds-text-safe {\n  min-width: 0;\n  overflow-wrap: break-word;\n  word-break: normal;\n}\n\n/* Narrow-viewport guard: if ANY admin surface accidentally sets\n   `white-space: nowrap` on a text container wider than its parent,\n   the result would overflow — ban that pattern in headings via the\n   lint test in tests/test_responsive_audit.py. */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
